import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class RegisterData {
  abstract save(params: any): Observable<ApiResponse>;
}
